import styled from 'styled-components';

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
  padding: var(--spacing-06);
  width: 100%;
  overflow: scroll;
  min-height: 130px;
  max-height: 400px;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  width: 100%;
`;

export const BackButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const PreviewTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #161616;
`;

export const PreviewContent = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #161616;
`;

export const RefreshButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 380px;
  color: var(--text-primary);
`;
